import React from 'react';
import { Database, MessageSquare, BarChart2, BookOpen } from 'lucide-react';

const integrations = [
  {
    name: 'CRM Systems',
    description: 'Seamless integration with popular CRM platforms',
    icon: Database,
  },
  {
    name: 'Communication Tools',
    description: 'Connect with your favorite collaboration apps',
    icon: MessageSquare,
  },
  {
    name: 'Analytics Platforms',
    description: 'Export and analyze data with your preferred tools',
    icon: BarChart2,
  },
  {
    name: 'Learning Resources',
    description: 'Access training and documentation platforms',
    icon: BookOpen,
  },
];

export function Integrations() {
  return (
    <div className="bg-gray-50 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Seamless Integrations
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Connect with your favorite tools and platforms
          </p>
        </div>

        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:max-w-none">
          <dl className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4">
            {integrations.map((integration) => (
              <div key={integration.name} className="text-center">
                <dt>
                  <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-indigo-600">
                    <integration.icon className="h-10 w-10 text-white" />
                  </div>
                  <p className="mt-6 text-lg font-semibold leading-8 text-gray-900">
                    {integration.name}
                  </p>
                </dt>
                <dd className="mt-2 text-sm text-gray-600">{integration.description}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}